module.exports = __webpack_public_path__ + "img/4.85ad8687.png";